import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'imobiliare-nivelul-2',
  meta: {
    siteTitle: 'Căruța cu bani - curs de investiții imobiliare nivelul 2',
    ogSiteName: 'Căruța Cu Bani',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://carutacubani.ro/cursuri/curs-investitii-imobiliare-nivelul-2/',
    ogImage: 'https://carutacubani.ro/cursuri/curs-investitii-imobiliare-nivelul-2/assets/images/imobiliare-nivel-2/cover-fb.png'
  }
};

export const environment = { ...commonCbEnv, ...env };
